/**
 * Locally-owned enums and interfaces that were previously imported from @vp/vp-js-token-engine.
 * The enum string values are kept identical to the token engine's to preserve compatibility
 * with any downstream consumers that rely on the string values.
 */

export enum ComparativeDisplayType {
  Always = "Always",
  Never = "Never",
  CustomerFriendly = "CustomerFriendly",
  Legacy = "Legacy",
}

export enum ZeroDisplayType {
  Zero = "Zero",
  BasePrice = "BasePrice",
  Included = "Included",
  Legacy = "Legacy",
}

export interface IPrice {
  listPrice: number;
  discountPrice: number;
  minimumFractionDigits: number;
  culture: string;
  currency: string;
  vatInc: boolean;
  hideVatMessage?: boolean;
  hideShippingMessageInVatMessage?: boolean;
}

export interface IUnitPrice {
  unitListPrice: number;
  unitDiscountPrice: number;
  minimumFractionDigits: number;
  culture: string;
  currency: string;
  vatInc: boolean;
  hideVatMessage?: boolean;
  hideShippingMessageInVatMessage?: boolean;
}

export interface IQuantityPrice {
  quantity: number;
  listPrice: number;
  discountPrice: number;
  currency: string;
  minimumFractionDigits: number;
  vatInc: boolean;
  hideVatMessage?: boolean;
  hideShippingMessageInVatMessage?: boolean;
  culture: string;
}

export interface IRangePrice {
  lowestListPrice: number;
  highestListPrice: number;
  lowestDiscountPrice: number;
  highestDiscountPrice: number;
  minimumFractionDigits: number;
  culture: string;
  currency: string;
  vatInc: boolean;
  hideVatMessage?: boolean;
  hideShippingMessageInVatMessage?: boolean;
}

export interface IPlusOrMinus {
  currency: string;
  minimumFractionDigits: number;
  culture: string;
  priceDifference: number;
  priceDifferenceDiscounted: number;
  zeroDisplayType?: ZeroDisplayType;
  comparativeDisplayType?: ComparativeDisplayType;
}

export interface IVatMessage {
  culture: string;
  vatInc: boolean;
  hideShippingMessageInVatMessage?: boolean;
}
